import ApisServiceAuth from '@api/ApisServiceAuth'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export function getDetailDuAn(id: string) {
  try {
    return ApisServiceAuth.get('/duan/' + id + '/get-chitiet-duan')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListDuAn(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceAuth.get('/duan/filter-duan', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
} 